import Vue from 'vue'
import Router from 'vue-router'
// import { Dialog } from 'vant'
import store from '@/store/index.js'
import { getRouteListByPermission } from '@/utils/routePermssion.js' // 根据权限获取路由列表，并给传入的菜单列表加上icon

import commonRoutes from '@/router/commonRoute'
import dev from '@/router/dev'
import dynamicRoutes from '@/router/dynamicRoute'

import { roleSelectUserRole } from '@/api/adminManagement.js'

Vue.use(Router)
// Vue.use(Dialog)

// const layoutComponent = () => import('@/views/layout');

// 公共路由
const constantRoutes = [...commonRoutes, ...dev]

// 动态路由，通过权限筛选的路由
const asyncRoutes = [...dynamicRoutes]

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: constantRoutes
})

// 权限数据
// let permissionData = [];

router.beforeEach((to, from, next) => {
  // 设置标题
  // window.document.title = to.meta.title
  if (to.name === 'login') {
    // store.getters.PermissionList = []
    store.commit('setPermissionList', [])
    store.commit('setMenuList', [])
    next()
    return
  }
  // console.log(to)

  // 检查登录token
  // const userData = JSON.parse(localStorage.getItem('userData'))
  const userinfo = (store.state.user) ? store.state.user.userinfo : undefined 
  // console.log(userData)
  if (
    // userData === undefined ||
    // userData === null ||
    // userData.token === undefined ||
    // userData.token === null ||
    // userData.token === ''
    // store.state.user === undefined ||
    userinfo === undefined ||
    userinfo.token === undefined ||
    userinfo.token === ''
  ) {
    // 如果不存在，则跳转到登录页面
    next({
      name: 'login',
      query: {
        fromFullPath: to.fullPath
      },
      params: to.params
    })
    return
  }

  // // 临时使用，全部路由
  // if (!store.getters.MenuList) {
  //   const routeListCur = asyncRoutes
  //   // store.getters.MenuList = routeListCur
  //   store.commit('setMenuList', routeListCur)
  //   router.addRoutes(routeListCur)
  //   next({
  //     ...to
  //   })
  //   return
  // } else {
  //   next()
  //   return
  // }

  // 权限列表
  let permissionList = store.getters.PermissionList
  if (
    !permissionList ||
    permissionList.length === 0
  ) {
    // 获取当前默认角色的资源
    roleSelectUserRole()
      .then(result => {
        let data = null
        permissionList = []// 权限资源数据
        if (result.code === 200) {
          // 获取成功
          data = result.data
        } else {
          data = null
        }
        // console.log(data)
        if (data && data.permissionList) {
          permissionList = data.permissionList
        } 
  
        if(permissionList && permissionList.length > 0){
          // 根据权限列表获取对应的路由列表
          const routeListCur = getRouteListByPermission(permissionList, asyncRoutes)
    
          // 缓存权限菜单
          // store.getters.PermissionList = permissionList
          // store.getters.MenuList = routeListCur
          // store.getters.MenuAllList = asyncRoutes
          store.commit("setPermissionList", permissionList)
          store.commit('setMenuList', routeListCur)

          // 添加到路由集合中
          router.addRoutes(routeListCur)
          
          // 如果是登录，则跳转有权限的最大角色的首页
          if((from.name == 'login' && to.params.isLogin) 
            || (to.query.isRoleHome != undefined && to.query.isRoleHome != null 
                && to.query.isRoleHome.toString().toLowerCase() == 'true')){//&& to.params.isLogin.toString().toLowerCase() == 'true'
            let toName = 'welcome'
            let homeArray = ['tooladmin','companyManager','projectManager','patentManager']
            for(let i = 0; i < routeListCur.length; i++){
              let routeCur = routeListCur[i]
              if(routeCur.path == '/home'){
                let children = routeCur.children
                if(children){
                  for(let m = 0; m < children.length; m++){
                    let child = children[m]
                    if(m == 0 || homeArray.indexOf(toName) > homeArray.indexOf(child.name)){
                      toName = child.name
                    }
                  }
                }

                break
              }
            }

            next({
              name: toName
            })

            return
          }

          next({
            ...to
          })
        }
        else{
          store.commit("setPermissionList", [])
          store.commit('setMenuList', [])
          next()
        }
      })
      .catch(() => {
        next()
      })
  } else {
    roleSelectUserRole()
      .then(result => {
        if (result.code === 404) {
          // token失效
          next(false)
        } else {
          next()
        }
      })

    // next()
  }

  return
})

export default router
